import Icon from '@/components/ui/AppIcon';

export default function PrivacyNotice() {
  return (
    <div className="mt-6 space-y-3">
      {/* Safety warning */}
      <div
        className="flex items-start gap-2 px-3 py-2 border border-warning/20 bg-warning/5"
        style={{ borderRadius: '2px' }}
      >
        <Icon name="ExclamationTriangleIcon" size={14} variant="solid" className="text-warning flex-shrink-0 mt-0.5" />
        <p className="font-mono text-xs text-warning/80 leading-snug">
          Erkunde immer sicher. Betrete keine Gebäude allein. Respektiere das Hausrecht.
        </p>
      </div>

      {/* DSGVO notice */}
      <div
        className="flex items-start gap-2 px-3 py-2 border border-white/5 bg-card"
        style={{ borderRadius: '2px' }}
      >
        <Icon name="ShieldCheckIcon" size={14} variant="outline" className="text-muted-foreground flex-shrink-0 mt-0.5" />
        <p className="font-mono text-xs text-muted-foreground/60 leading-snug">
          Datenschutz gemäß DSGVO · Keine persönlichen Daten gespeichert · Koordinaten werden anonymisiert
        </p>
      </div>
    </div>
  );
}